import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ExportOptions, IActualSystemMenuPermission } from 'src/app/tabms/models/base/base';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { PermissionsListService } from 'src/app/tabms/services/global/permissions-list.service';
import { UserFavouritePageService } from 'src/app/tabms/services/global/user-favourite-page.service';
import { ADDTOFAV, OPERERROR, REMOVEVEF } from 'src/app/tabms/tab-consts';
import { BaseFilterComponent } from '../../base-page-tools/base-filter/base-filter.component';
import { FieldsConfigService } from 'src/app/tabms/services/global/fields-config.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { TabSystemMenuService } from 'src/app/tabms/services/menu/tab-system-menu.service';
import { CommandService } from 'src/app/tabms/services/global/command.service';

@Component({
  selector: 'app-page-tools',
  templateUrl: './page-tools.component.html',
  styleUrl: './page-tools.component.scss'
})
export class PageToolsComponent<T> {
  //#region inputs
  @Input() set service(_service) {
    if (!_service) return;
    this.serviceInstance = _service;
  }
  //#endregion

  userId;
  systemMenuId;
  userFavouritePageId;
  isFavourite = false;
  favColor = '#000000';
  printListFields;
  //#region public prop
  serviceInstance;
  selectedOption: string;
  exportOptions: ExportOptions[];
  // screen: string;
  permissions: IActualSystemMenuPermission;
  menuKey: string;
  pageParameter: string;
  extraDynamicMenu
  private destroy$: Subject<void> = new Subject<void>();

  //#endregion

  //#region constructor
  constructor(
    public dialog: MatDialog,
    private baseService: BaseService,
    private activatedRoute: ActivatedRoute,
    private userFavouritePageService: UserFavouritePageService,
    private permissionListService: PermissionsListService,
    private fieldsConfigServiceInstance: FieldsConfigService<T>,
    private sessionService: SessionWrapperService,
    private tabSystemMenuService: TabSystemMenuService,
    private commandService: CommandService
  ) {
    // this.screen = activatedRoute.snapshot.url[0].path;
    // console.log('this.screen', this.screen);
  }
  //#endregion

  //#region life hooks
  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe({
      next: (params) => {
        this.systemMenuId = params['id'];
        console.log('this.systemMenuId', this.systemMenuId);
        this.getMenuKey(this.systemMenuId);
      }
    });

    this.permissionListService
      .getPagePermissions()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.permissions = res;
          this.setOptions();
        }
      });

    this.userFavouritePageService.getUserFavouritePages()?.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        let userFavPages = res.result;
        if (userFavPages) {
          this.userFavouritePageId = userFavPages.find((x) => x.tabsystemmenuid == this.systemMenuId)?.id;
          this.isFavourite = this.userFavouritePageId ? true : false;
          this.favColor = this.isFavourite ? '#ddcd0a' : '#000000';
        }
      },
      error: (err) => {
        console.log('userFavouritePageService.getbyParam err', err);
        this.isFavourite = false;
      }
    });

    this.baseService.clearPageSelectedOption.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.selectedOption = '';
    });
  }
  //#endregion

  //#region filter
  showFilterPopup() {
    this.dialog.open(BaseFilterComponent, {
      width: '800px',
      data: { service: this.serviceInstance, fieldsConfigServiceInstance: this.fieldsConfigServiceInstance },
      direction: this.baseService.getDirection()
    });
  }
  //#endregion

  //#region Export Options
  setOptions() {
    if (this.permissions?.print && this.permissions?.export) {
      this.exportOptions = [
        { value: 'excel', viewValue: 'exportExcel' },
        { value: 'csv', viewValue: 'exportCSV' },
        { value: 'pdf', viewValue: 'exportPdf' },
        { value: 'temp', viewValue: 'downloadTemplate' }
      ];
    }
    else if (!this.permissions?.print && this.permissions?.export) {
      this.exportOptions = [];
    }
  }

  onOptionClicked(selectedOption) {

    this.baseService.exportOptionsChange.next(selectedOption);
  }
  //#endregion

  //#region create
  showCreate() {
    this.baseService.createFormDisplay.next({ show: true, id: null });
  }
  //#endregion

  //#region favourite
  favouriteClick() {
    if (this.isFavourite) {
      this.favColor = '#000000';
      this.removeFavourite();
    } else {
      this.favColor = '#ddcd0a';
      this.addFavourite();
    }
    this.isFavourite = !this.isFavourite;
  }

  addFavourite() {
    let claims = JSON.parse(sessionStorage.getItem('id_token_claims_obj'));
    if (claims) {
      this.userId = claims['sub'];
    }
    let userFavourite = {
      identityuserid: this.userId,
      tabsystemmenuid: this.systemMenuId,
      menukey: this.menuKey,
      pageparameter: this.pageParameter
    };
    this.userFavouritePageService.create(userFavourite)?.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.userFavouritePageId = res?.result?.id;
        this.baseService.showSuccessMessage(ADDTOFAV);
        this.baseService.addRemoveFavourite.next(1);
      },
      error: (err) => {
        console.log('userFavouritePage create err', err);
        this.baseService.showErrorMessage(OPERERROR);
      }
    });
  }

  removeFavourite() {
    this.userFavouritePageService.delete(this.userFavouritePageId)?.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.baseService.showSuccessMessage(REMOVEVEF);
        this.baseService.addRemoveFavourite.next(2);
      },
      error: (err) => {
        console.log('userFavouritePageService.delete err', err);
        this.baseService.showErrorMessage(OPERERROR);
      }
    });
  }
  //#endregion

  getMenuKey(id) {
    this.tabSystemMenuService.get(id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.menuKey = res.result.menukey;
        this.pageParameter = res.result.pageparameters;
        // console.log('this.menuKey', this.menuKey);
        this.sessionService.setMenuKeyAndPageParameter(this.menuKey, this.pageParameter);

      }
    });
  }


  //#region dynamic methods
  getExtraDynamicMenu() {
    this.commandService.getAll().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res.result && res.result.length > 0) {
          this.extraDynamicMenu = res.result.filter((x) => x.tabsystemmenuid == this.systemMenuId && x.type == 1);
        }
      },
      error: (err) => {
        console.log('getExtraDynamicMenu err', err);
      }
    });
  }

  //#endregion

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

